<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 添加按钮 -->
      <template #start>
        <el-form-item class="startBtn" v-if="user && [1, 2, 3, 4, 5].includes(user.user_group_id)">
          <el-button type="primary" icon="el-icon-plus" @click="addItem">添加</el-button>
        </el-form-item>
      </template>
      <!-- 复合搜索框 -->
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showIndex="true"
      :btns="btns" :showTotal="true" :getTotal="getTotal" @onSelectionChange="onSelectionChange"
      @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <FormDialog ref="dialog" :title="title" :labelWidth="'110px'" :form="mform" :formCtrl="mformCtrl"
      :viewMode="viewMode" @onModalSubmit="onModalSubmit"></FormDialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "MakeupList",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'compen',
      breadcrumb: [
        { name: "订单管理" },
        { name: "订单补差" },
      ],
      formCtrl: [
        {
          label: "装货日期：",
          keyName: "starttime",
          placeholder: "请选择日期",
          type: "date",
        },
        // {
        //   label: "补差日期：",
        //   keyName: "edittime",
        //   placeholder: "请选择补差日期",
        //   type: "date",
        // },
        // {
        //   label: "车牌号：",
        //   keyName: "license",
        //   placeholder: "请填写车牌号",
        //   type: "text",
        // },
        // {
        //   label: "订单号：",
        //   keyName: "order_num",
        //   placeholder: "请填写订单号",
        //   type: "text",
        // },
        // {
        //   label: "客户名称：",
        //   keyName: "shname",
        //   placeholder: "请填写客户名称",
        //   type: "text",
        // },
        // {
        //   label: "显示：",
        //   keyName: "iscar",
        //   type: "select",
        //   options: [
        //     { label: '全部', value: 0 },
        //     { label: '运费增加', value: 1 },
        //     { label: '利润增加', value: 2 },
        //     { label: '全部增加', value: 3 },
        //   ],
        // },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchKeyOptions: [
        { label: '车牌号', value: 'license', },
        { label: '订单号', value: 'order_num', },
        { label: '客户名称', value: 'shname', },
      ],
      cols: [
        { prop: "order_num", label: "订单号" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "shname", label: "客户名称" },
        { prop: "starttime", label: "装货日期", width: 120 },
        { prop: "edittime", label: "补差日期" },
        { prop: "money", label: "补差金额", align: 'right', className: 'pr30' },
        { prop: "content", label: "备注信息" },
      ],
      btns: [
        {
          ...this.viewBtn,
          cb: (data) => {
            // this.setModalData(data)
            // this.showDialog()
            this.$router.push(
              `/order/makeupedit?mode=view&id=${data.id}`
            );
          },
        },
      ],
      getTotalProperty: ['money'],
      title: '修改补差金额',
      viewMode: false,
      mform: {},
      mformCtrl: [
        {
          label: "订单号",
          keyName: "order_num",
          err: "请填写订单号",
          type: "text",
          viewMode: true,
        },
        {
          label: "客户名称",
          keyName: "shname",
          err: "请填写客户名称",
          type: "text",
          viewMode: true,
        },
        {
          label: "车牌号",
          keyName: "license",
          err: "请填写车牌号",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货地址",
          keyName: "coaddress",
          err: "请填写装货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货地址",
          keyName: "enaddress",
          err: "请填写卸货地址",
          type: "text",
          viewMode: true,
        },
        {
          label: "装货重量",
          keyName: "inton",
          err: "请填写装货重量",
          type: "text",
          viewMode: true,
        },
        {
          label: "卸货重量",
          keyName: "unton",
          err: "请填写卸货重量",
          type: "text",
          viewMode: true,
        },
        {
          label: "运费",
          keyName: "infreight",
          err: "请填写运费",
          type: "text",
          viewMode: true,
        },
        {
          label: "补差金额",
          keyName: "money",
          err: "请填写补差金额",
          type: "number",
        },
        {
          label: "运费增加",
          keyName: "iscustom",
          type: "radio",
          options: [
            { label: '是', value: '1' },
            { label: '否', value: '2' },
          ],
        },
        {
          label: "利润增加",
          keyName: "iscar",
          type: "radio",
          options: [
            { label: '是', value: '1' },
            { label: '否', value: '2' },
          ],
        },
        {
          label: "备注",
          keyName: "content",
          err: "请填写备注信息",
          type: "textarea",
        },
      ],
    };
  },
  methods: {
    addItem() {
      this.$router.push(
        `/order/makeupdetail?mode=add`
      );
    },
    setModalData(data) {
      this.mformCtrl.map(v => {
        const key = v.keyName
        this.mform[key] = data[key]
      })
      this.mform.id = data.id
      this.mform.orderid = data.orderid
    },
    onModalSubmit() {
      console.log({ ...this.mform })
      let url = `${this.baseUrl}/addedu`
      const params = {
        ...this.mform,
      }
      this.loading = true
      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.hideDialog()
          this.getList()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    const { user_group_id } = this.user
    if ([1, 2, 3, 4, 5].includes(user_group_id)) {
      this.btns[0] = {
        ...this.editBtn,
        cb: (data) => {
          // this.setModalData(data)
          // this.showDialog()
          this.$router.push(
            `/order/makeupedit?mode=edit&id=${data.id}`
          );
        },
      }
    }
  },
};
</script>
<style lang="less" scoped>
/deep/ .el-table .pr30 .cell {
  padding-right: 30px;
}
</style>